import { useEffect } from "react";

const PRIVACY_URL = "https://sites.google.com/view/nfpprivacypolicy/home";

export default function Privacy() {
  useEffect(() => {
    window.location.replace(PRIVACY_URL);
  }, []);

  return (
    <div
      className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6 text-center"
      data-testid="page-privacy"
    >
      <div>
        <p className="text-[11px] tracking-[0.3em] uppercase text-[#1FA2FF]">Redirecting</p>
        <h1 className="nfp-heading text-3xl mt-3">Privacy Policy</h1>
        <p className="mt-3 text-white/60 max-w-md mx-auto">
          You are being redirected to the NFP Privacy Policy. If your browser
          doesn't redirect,{" "}
          <a href={PRIVACY_URL} className="text-[#00E5FF] hover:underline">
            click here
          </a>
          .
        </p>
      </div>
    </div>
  );
}
